
import {HandPointRestAPIDriver} from '../handPoint/handPointRestApiDriver';
var underlyingDriver;

export function connect(creditCardTerminalConfiguration, onConnect, onConnectionError)
{
    underlyingDriver = new HandPointRestAPIDriver(creditCardTerminalConfiguration.url, creditCardTerminalConfiguration.apiKey, creditCardTerminalConfiguration.terminalId);
    underlyingDriver.connect(onConnect, onConnectionError)
}

export function chargeAmount (saleId, amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline)
{
    underlyingDriver.chargeAmount(amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline);
}

export function refundAmount (amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline)
{
    underlyingDriver.refundAmount(amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline);
}
